import react, {useEffect, useState} from 'react'
import {Link, useNavigate} from "react-router-dom";
import commonStyles from "../commonStyles";
import React from "react";
import CardRisultato from "./CardRisultato";
import { atomWithHash } from "jotai/utils";
import { useAtom } from "jotai";
import CardPersona from "./CardPersona";

function ListaPersone(props) {

    useEffect(() => {
        console.log(props.persone)
    }, [])

    return(
        <div className="container" style={ commonStyles.divRisultati }>
            <div className="row" style={{ margin: 'auto', flexWrap: 'wrap' }}>
                <div className="col" style={{ margin: 'auto', flexWrap: 'wrap' }}>

                    <hr style={ commonStyles.hr }/>
                    <div style={{ color: 'white' }}>
                        <button onClick={ () => { props.onBack() } } className={"btn coolbtn btn-outline-light  ms-2 me-2 px-3"}>
                            <>BACK </>
                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" className="bi bi-box-arrow-left" viewBox="0 2 16 16">
                                <path fillRule="evenodd"
                                      d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"/>
                                <path fillRule="evenodd"
                                      d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"/>
                            </svg>
                        </button>
                    </div>
                    <hr style={ commonStyles.hr }/>

                    {props.persone.length !== 0?
                        props.persone.map(persona => (
                            <CardPersona
                                key={ persona.id }
                                persona = { persona }
                                flag = { props.flag }
                                onDelete = { props.onDelete }
                            />
                        )) : <h3>No Friends Added</h3>
                    }
                </div>
            </div>
        </div>
    );
}

export default ListaPersone